exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AuthorCard__authorContainer--24gS7 {\n  font-weight: 400;\n  height: 120px;\n  padding: 20px 0;\n  font-size: 16px;\n  cursor: pointer;\n}\n\na {\n  color: #f9f9f9;\n}\n\n.AuthorCard__authorTextBox--2gbCe {\n  padding: 10px 30px;\n}\n\n.AuthorCard__authorBio--3QWwy {\n  opacity: 0.65;\n  font-weight: 100;\n  font-size: 14px;\n  padding-top: 10px;\n}", ""]);

// exports
exports.locals = {
	"authorContainer": "AuthorCard__authorContainer--24gS7",
	"authorTextBox": "AuthorCard__authorTextBox--2gbCe",
	"authorBio": "AuthorCard__authorBio--3QWwy"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };